import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { UserRolle } from '@hrh/shared';

import { LoadingScreen } from '@/components/loading-screen.js';
import { useAuth } from '@/features/auth/hooks/use-auth.js';

interface AuthGuardProps {
  allow: readonly UserRolle[];
  children: ReactNode;
}

export function AuthGuard({ allow, children }: AuthGuardProps): JSX.Element {
  const { user, isLoading } = useAuth();
  if (isLoading) return <LoadingScreen message="Anmeldung wird geprüft …" />;
  if (!user) return <Navigate to="/login" replace />;
  if (!allow.includes(user.rolle)) {
    return <Navigate to={user.rolle === 'disponent' ? '/dashboard' : '/portal'} replace />;
  }
  return <>{children}</>;
}
